import { CircularProgress, CircularProgressProps } from "@mui/material";
import React from "react";

import "./AsyncContent.styles.scss";

interface AsyncContentProps {
  loading: boolean;
  children: React.ReactNode;
  spinnerProps?: CircularProgressProps;
  className?: string;
  loaderClassName?: string;
}

export const AsyncContent: React.FC<AsyncContentProps> = ({
  loading,
  children,
  spinnerProps,
  className = "content",
  loaderClassName = "async-content-loader"
}): JSX.Element => {
  return loading ? (
    <div className={loaderClassName}>
      <CircularProgress {...spinnerProps} />
    </div>
  ) : (
    <div className={className}>{children}</div>
  );
};
